import {
  UseMutateAsyncFunction,
  useMutation,
} from "@tanstack/react-query";
import {
  FileImportPreviewResponseDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_AI_FILE_SEARCH } from "../domain";

import { aiFileSearchApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_IMPORT_FROM_FILES = "IMPORT_FROM_FILES";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

type ImportFromFilesRequest = {
  formId: string;
  files: File[];
};

const importFromFiles = async (
  req: ImportFromFilesRequest,
): Promise<FileImportPreviewResponseDto> => {
  const response =
    await aiFileSearchApi.aiFileSearchControllerImportFromFiles(
      req.formId,
      req.files,
    );

  return response.data;
};

export const useImportFromFiles = (
  user: UserProfileDto | null,
): {
  importFromFilesAsync: UseMutateAsyncFunction<
    FileImportPreviewResponseDto,
    Error,
    ImportFromFilesRequest,
    unknown
  >;
  importFromFilesEnabled: boolean;
  isSuccessImportFromFiles: boolean;
  isPendingImportFromFiles: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);

  const { mutateAsync, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_AI_FILE_SEARCH, ACTION_IMPORT_FROM_FILES],
    mutationFn: enabled ? importFromFiles : undefined,
  });

  return {
    importFromFilesAsync: mutateAsync,
    importFromFilesEnabled: enabled,
    isSuccessImportFromFiles: isSuccess,
    isPendingImportFromFiles: isPending,
  };
};
